import React from 'react';
import { NavBar } from '../../../components/essentials/navbar/navbar.component';
import { Footer } from '../../../components/essentials/footer/footer.component';
import { Getstarted } from '../../../components/essentials/get-started/getstarted.component';
import { OverlapBoxTechno } from '../techno.component';
import phoneImg from '../../../assest/phoneImg/Distributed  Ledger.png';
import './distributed.styles.scss';
import { useTranslation } from 'react-i18next';

export const DistributeLedger = () => {
  const { t } = useTranslation('distributed-ledger');

  return (
    <div className='blogs-main'>
      <NavBar />
      <HeaderHalf title={t('pageTitle')} uris={t('pageUri')} />
      <OverlapBoxTechno
        img={phoneImg}
        title={t('headerTitle')}
      >
        <p>{t('section1')}</p>
        <p>{t('section2')}</p>
        <p>{t('section3')}</p>
      </OverlapBoxTechno>
      <Getstarted />
      <Footer />
    </div>
  );
};

const HeaderHalf = ({ title, uris }) => {
  return (
    <div className='headerHalf-main-distribute'>
      <div className='headerHalf-content'>
        <p className='headerHalf-title'>{title}</p>
        <p className='headerHalf-uris'>
          Platform / <span className='uris-class'>{uris}</span>
        </p>
      </div>
    </div>
  );
};
